/**
 * 组件：登陆页面
 */
import React, { Component } from 'react';
import { Form, Input, Checkbox, Button } from 'antd';
import Login_bg from '../College/assets/images/login-bg.jpg';
import Logo from '../College/assets/images/qingcloud.png';
import './index.less';

class Login extends Component {
  onFinish = (values: any) => {
    // console.log('Success:', values);
  };

  onFinishFailed = (errorInfo: any) => {
    // console.log('Failed:', errorInfo);
  };

  render() {
    const layout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };
    const tailLayout = {
      wrapperCol: { offset: 6, span: 16 },
    };
    return (
      <div className="college_login" style={{backgroundImage: `url(${Login_bg})`}}>
        <div className="right">
          <div className="loginform">
            <div className="inner">
              <img src={Logo} alt=""/>
              <Form
                {...layout}
                // layout='vertical'
                name="basic"
                initialValues={{ remember: true }}
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
              >
                <Form.Item
                  label="用户名"
                  name="username"
                  rules={[{ required: true, message: '请输入用户名!' }]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="密码"
                  name="password"
                  rules={[{ required: true, message: '请输入密码!' }]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item {...tailLayout} name="remember" valuePropName="checked">
                  <Checkbox>记住密码</Checkbox>
                </Form.Item>

                <Form.Item {...tailLayout}>
                  <Button type="primary" htmlType="submit">
                    登陆
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Login;
